import { apiSlice } from 'pm-api';

export interface SummaryChartData {
    name: string;
    value: number;
    color: string;
}

interface SummaryChartResponse {
    data: SummaryChartData[];
}

interface MonthlyChartExpense {
    name: string;
    value: number;
    color: string;
}

interface MonthlyChartData {
    name: string;
    expenses: MonthlyChartExpense[];
}

interface MonthlyChartResponse {
    data: MonthlyChartData[];
}

export type MonthlyChartMonth = { name: string } & Record<string, number | string>;

export interface MonthlyChartResult {
    data: MonthlyChartMonth[];
    metadata: {
        categoryToColor: Record<string, string>;
    };
}

export const analyticsApiSlice = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getSummaryChartData: build.query({
            query: (query) => ({
                url: '/auth/analytics/summary',
                params: query,
            }),
            transformResponse: (response: SummaryChartResponse) => {
                return response.data;
            },
        }),
        getMonthlyChartData: build.query<MonthlyChartResult, { from: string; to: string }>({
            query: (query) => ({
                url: '/auth/analytics/monthly',
                params: query,
            }),
            transformResponse: (response: MonthlyChartResponse) => {
                const categoryToColor: Record<string, string> = {};

                const data = response.data.map((month) => {
                    const flatMonth: MonthlyChartMonth = { name: month.name };

                    (month.expenses ?? []).forEach((expense) => {
                        flatMonth[expense.name] = expense.value;
                        categoryToColor[expense.name] = expense.color;
                    });

                    return flatMonth;
                });

                return { data, metadata: { categoryToColor } };
            },
        }),
    }),
});

export const {
    useGetSummaryChartDataQuery,
    useGetMonthlyChartDataQuery,
} = analyticsApiSlice;
